import { approveConstants } from "../constant/approve.constants";

export const initialState = {
    dataApprove: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const approveReducer = (state = initialState, action) => {
    switch (action.type) {
        case approveConstants.GET_SUCCESS:
            return {
                ...state,
                dataApprove: action.approveList,
                isLoading: false
            };
        case approveConstants.GET_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };

        default:
            return state;
    }
};

export default approveReducer;
